import Navigation from "../Navigation";

export default function ArticlePage({ navData, baseRoute, orderNav = true, children }) {
  return (
    <div className="flex flex-col xl:flex-row">
      <div className="flex-none xl:flex xl:flex-col xl:w-1/4 mb-16 xl:mb-0">
        {navData ? (
          <Navigation
            data={navData}
            parent={baseRoute}
            order={orderNav}
            itemClass="text-lg mb-0 xl:mb-10 mr-8 xl:mr-0 inline-block"
            activeStyle="text-epsilon"
          />
        ) : null}
      </div>
      <div className="flex-grow">{children}</div>
      <div className="flex-none xl:w-1/4"></div>
    </div>
  );
}
